import styled from 'styled-components';

export const Wrapper = styled.div`
  display: block;
  height: calc(100vh - 51px);
  overflow-y: auto;
  overflow-x: hidden;
`;
